<div
  [ngClass]="classes"
  [ngStyle]="{ transform: transformation, display: display }"
  role="img"
  [attr.alt]="alt"
  title="{{ alt }}"
></div>
